var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOnlineBakhishIconMini = function SvgOnlineBakhishIconMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 39,
    fill: "none",
    viewBox: "0 0 28 29"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#onlineBakhishIconMini_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "M15.625 11.394H9.42c-1.11 0-2.01.902-2.01 2.015v2.667c0 1.112.9 2.014 2.01 2.014h6.204c1.11 0 2.009-.902 2.009-2.014v-2.667c0-1.113-.9-2.015-2.01-2.015m-6.204-.652a2.663 2.663 0 0 0-2.66 2.667v2.667a2.663 2.663 0 0 0 2.66 2.666h6.204a2.663 2.663 0 0 0 2.659-2.666v-2.667a2.663 2.663 0 0 0-2.66-2.667z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#onlineBakhishIconMini_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "M12.425 9.178a1.51 1.51 0 0 0 1.395 1.155l-.098-1.257zm1.258-.604-1.294.101a1.52 1.52 0 0 1 1.198-1.333zm.54.463.096 1.234a1.51 1.51 0 0 0 1.073-1.326zm1.125-.594-1.164.091-.094-1.21a1.505 1.505 0 0 1 1.258 1.12m.4 1.145a2.017 2.017 0 0 0-1.096-2.63 2.007 2.007 0 0 0-2.621 1.1 2.017 2.017 0 0 0 1.095 2.629c1.027.423 2.2-.07 2.622-1.099",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#onlineBakhishIconMini_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "M10.09 7.35a1.5 1.5 0 0 0-1.574.894l1.205.358zm.113 1.394.368-1.248q.194.096.359.251c.38.359.533.867.454 1.347zm-.624.34-1.184-.35a1.51 1.51 0 0 0 .852 1.478zm.151 1.267.33-1.124 1.161.344q-.09.167-.226.313c-.338.36-.81.517-1.265.466m-1.21-.035c.81.763 2.08.724 2.841-.087a2.02 2.02 0 0 0-.087-2.848 2.005 2.005 0 0 0-2.84.087 2.02 2.02 0 0 0 .087 2.848",
    clipRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#onlineBakhishIconMini_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "m13.384 20.935-1.157-2.018-1.156 2.018zm-.496-2.402a.76.76 0 0 0-1.321 0L10.41 20.55a.77.77 0 0 0 .661 1.153h2.313c.587 0 .954-.64.66-1.153z",
    clipRule: "evenodd"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#onlineBakhishIconMini_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M20.209 17.695c-.24.002-.472-.079-.656-.229L17.84 16.09a.37.37 0 0 1-.146-.251.36.36 0 0 1 .2-.37.38.38 0 0 1 .426.049l1.713 1.376a.22.22 0 0 0 .172.06.28.28 0 0 0 .194-.077.26.26 0 0 0 .08-.19l.006-3.752a.26.26 0 0 0-.156-.243.28.28 0 0 0-.29.036l-1.72 1.377a.38.38 0 0 1-.424.046.38.38 0 0 1-.186-.223.36.36 0 0 1 .131-.397l1.72-1.377a1.04 1.04 0 0 1 1.094-.13c.176.081.325.21.43.372s.159.349.158.54l-.006 3.753a1 1 0 0 1-.302.712 1.03 1.03 0 0 1-.727.294"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "onlineBakhishIconMini_svg__a",
    width: 24.322,
    height: 20.8,
    x: 0.362,
    y: 4.342,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.698039 0 0 0 0 0.121569 0 0 0 0 0.121569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_84_19101"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_84_19101",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "onlineBakhishIconMini_svg__b",
    width: 16.82,
    height: 16.831,
    x: 5.48,
    y: 0.409,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.698039 0 0 0 0 0.121569 0 0 0 0 0.121569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_84_19101"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_84_19101",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "onlineBakhishIconMini_svg__c",
    width: 16.818,
    height: 16.831,
    x: 1.488,
    y: 0.432,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.698039 0 0 0 0 0.121569 0 0 0 0 0.121569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_84_19101"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_84_19101",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "onlineBakhishIconMini_svg__d",
    width: 16.641,
    height: 16.355,
    x: 3.907,
    y: 11.748,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.698039 0 0 0 0 0.121569 0 0 0 0 0.121569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_84_19101"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_84_19101",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "onlineBakhishIconMini_svg__e",
    width: 16.35,
    height: 18.57,
    x: 11.293,
    y: 5.526,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.698039 0 0 0 0 0.121569 0 0 0 0 0.121569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_84_19101"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_84_19101",
    result: "shape"
  })))));
};
export default SvgOnlineBakhishIconMini;